import $ from 'jquery';

// @ts-expect-error We're vendoring jQuery
$.fn.inlineEditable = function (commit: (e: FocusEvent) => void, cancel: (e: KeyboardEvent) => void) {
  this.addClass('text-editable');
  this.attr('contenteditable', 'true');
  this.off('focus').focus(function () {
    // @ts-expect-error Shadows outer this
    $(this).data('originalValue', $(this).text());
    return true;
  });

  this.off('blur').blur(function (e: FocusEvent) {
    // @ts-expect-error Shadows outer this
    const oldVal = $(this).data('originalValue');
    // @ts-expect-error Shadows outer this
    const newVal = $(this).text();
    if (newVal !== oldVal) {
      // @ts-expect-error Shadows outer this
      $(this).data('originalValue', newVal);
      commit(e);
    }
  });

  this.off('keydown').keydown(function (e: KeyboardEvent) {
    // Enter
    if (e.which === 13) {
      e.preventDefault();
      // @ts-expect-error Shadows outer this
      $(this).blur();
    }
    // Esc
    if (e.which === 27) {
      // @ts-expect-error Shadows outer this
      const oldVal = $(this).data('originalValue');
      // @ts-expect-error Shadows outer this
      $(this).text(oldVal);
      // @ts-expect-error Shadows outer this
      $(this).blur(); // This won't commit since original value == new value
      if (typeof cancel === 'function') {
        cancel(e);
      }
    }
  });
  return this;
};

// @ts-expect-error We're vendoring jQuery
$.fn.removeInlineEditable = function () {
  this.removeClass('text-editable');
  this.attr('contenteditable', 'false');
  this.off('focus');
  this.off('keydown');
  this.off('blur');
};
